import { Box, Grid, Tooltip } from '@material-ui/core';
import { Help } from '@material-ui/icons';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { Document } from '@roc/feature-types';
import { StandardDialog, Button } from '@roc/ui';
import { TrackRecordResolutionForm } from 'libs/feature-borrower-review/src/components/utils/trackRecordResolutionForm';
import { useResolutionStore } from 'libs/feature-borrower-review/src/hooks/useResolutionStore';
import { observer } from 'mobx-react';

export type ResolutionItemProps = {
  open?: boolean;
  onClose?: () => void;
  loanTaskId?: number;
  document: Document;
};

export const TrackRecordResolutionItem = observer((
  props: ResolutionItemProps
) => {
  const { open, onClose, loanTaskId, document } = props;
  const taskId = document?.taskId;
  const { resolutionStore } = useResolutionStore();
  const { tooltTipTitle } = resolutionStore;
  const { readOnly } = resolutionStore;

  const getTitle = () => {
    return (
      <Grid container spacing={2} >
        Resolution Needed
        <Tooltip
          placement="right"
          title={<p style={{ fontSize: '12px' }}> {tooltTipTitle} </p>}
        >
          <Help color="primary" style={{ fontSize: '18px', marginLeft: '3px', marginBottom: '5px' }} />
        </Tooltip>
      </Grid>
    );
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title={'Resolution'}
          handleClose={onClose}
          dialogContent={<div style={{ width: '100%' }}>
            <Box marginBottom={'24px'} marginTop={'12px'}>{getTitle()}</Box>
            <TrackRecordResolutionForm handleClose={onClose} loanTaskId={loanTaskId} readOnly={readOnly} />
          </div>}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title={getTitle()}
          maxWidth={false}
          PaperProps={{
            style: {
              width: '700px',
              maxWidth: '90vw'
            }
          }}
          handleClose={onClose}
          dialogContent={<div style={{ marginTop: '-40px' }}><TrackRecordResolutionForm handleClose={onClose} loanTaskId={loanTaskId} readOnly={readOnly} /></div>}
        />
      )}
    </>
  );
});

export default TrackRecordResolutionItem;
